export { default as TabLayout } from './TabLayout'
export { default as TabLayoutPlaceholder } from './TabLayoutPlaceholder'
export { default as classes } from './TabLayout.module.scss'
